const menus = [
  {
    title: '首页',
    path: '/home',
  },
  {
    title: '课程中心',
    path: '/grades',
  },
  {
    title: '师资培训',
    path: '/training',
  },
  {
    title: 'NOC赛事',
    path: '/match',
    verify: true,
  },
  {
    title: 'AI备课',
    path: '/aitools'
  },
  {
    title: '资源中心',
    path: '/resource',
  },
  {
    title: '素养评测',
    path: '/evaluation',
  },
  {
    title: '信息中心',
    path: '/news',
  },
  {
    title: '小果编程',
    path: '/code',
  },
]

export default menus
